export default __webpack_public_path__ + "static/expedience-43a22f25f19adf733d521ae953929e3c.jpg";